import React from 'react';
import { motion } from 'framer-motion';
import {FaUserTie,FaHandPointRight,FaRegCheckCircle} from "react-icons/fa";

const Cta = ({ctas,handleShowForm,gradientClass,textColor,textShadow}) => {
  return (
    <>
      <motion.div 
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.5 }}
          viewport={{ once: true }}
          className={`mt-16 ${gradientClass} rounded-xl shadow-xl p-8 text-center text-white`}
        >
          <h3 className="text-2xl lg:text-3xl font-bold mb-4">{ctas.title}</h3>
          <p className="text-xl text-purple-100 mb-6 max-w-2xl mx-auto">
            {ctas.description}
          </p>
          <motion.button
            onClick={handleShowForm}
            whileHover={{ scale: 1.05, boxShadow: "0 10px 25px -5px rgba(255, 255, 255, 0.3)" }}
            whileTap={{ scale: 0.98 }}
            className={`bg-white ${textColor} py-4 px-8 rounded-lg text-lg font-bold inline-flex items-center shadow-lg`}
          >
            <FaHandPointRight className="mr-3" />
            {ctas.button_text}
          </motion.button>
          <p className={`mt-4 ${textShadow} text-sm`}>Limited seats available - Registration closes soon</p>
        </motion.div>
    </>
  )
}

export default Cta
